/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetReleasePolicyPathParams = NonNullable<operations['GetReleasePolicy']['parameters']['path']>;

export interface Input extends GetReleasePolicyPathParams {
  apiVersion?: string;
  header: NonNullable<operations['GetReleasePolicy']['parameters']['header']>;
}

export async function GetReleasePolicy(
  { apiVersion, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/release-policies/{policyKey}', {
    params: { path, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
